"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJsonFile = isJsonFile;
exports.mergeDeep = mergeDeep;
function isJsonFile(file) {
    const extension = (file !== null && file !== void 0 ? file : '').split('.').pop();
    return (extension === null || extension === void 0 ? void 0 : extension.toLocaleLowerCase()) === 'json';
}
function isObject(value) {
    return value && typeof value === 'object' && !Array.isArray(value);
}
function mergeDeep(targetObj, sourceObj) {
    const target = targetObj !== null && targetObj !== void 0 ? targetObj : {};
    const source = sourceObj !== null && sourceObj !== void 0 ? sourceObj : {};
    Object.keys(source).forEach((key) => {
        if (isObject(source[key])) {
            if (!(key in target)) {
                target[key] = source[key];
            }
            else {
                target[key] = mergeDeep(target[key], source[key]);
            }
        }
        else {
            target[key] = source[key];
        }
    });
    return target;
}
